<section>
  <div class="title--container">
    @if (flask()) {
      <span class="flask subtitle2">{{ flask() }}</span>
    }
    @if (flaskIcon) {
      <app-svg-template
        [iconName]="flaskIcon"
        [title]="flaskIcon"
        height="30"
        width="30"
        customViewBox="0 0 30 30"
      ></app-svg-template>
    }
  </div>
  <div>
    <span class="body2 title">OD: </span
    ><span class="body2 data">{{
      dataReading() === null || dataReading() === undefined
        ? '-'
        : (dataReading() | number: '1.2-2')
    }}</span>
  </div>
  <div>
    <span class="body2 title">Last OD reading: </span
    ><span class="body2 data">
      {{ time() === null || time() === undefined ? '-' : (time() | date: 'HH:mm a, dd/MM/yy') }}</span
    >
  </div>
  <div>
    <span class="body2 title">Temperature: </span
    ><span class="body2 data">
      {{ temperatureReading() === null || temperatureReading() === undefined ? '-' : (temperatureReading() | number: '1.2-2') }}
    </span>
  </div>
  <div>
    <span class="body2 title">Stirring speed: </span
    ><span class="body2 data">
      {{ speedRPMReading === null || speedRPMReading === undefined ? '-' : speedRPMReading }}
    </span>
  </div>
</section>
